import dayjs from 'dayjs';

/**
 * 校验时间格式是否为 HH:MM
 * @param timeStr 待校验的时间字符串
 * @returns 校验结果
 */
export const isValidTimeFormat = (timeStr: string): boolean => {
  const timeRegex = /^([01]\d|2[0-3]):[0-5]\d$/;
  return timeRegex.test(timeStr);
};

/**
 * 将 HH:MM 格式的时间转换为总分钟数
 * @param timeStr HH:MM 格式时间
 * @returns 总分钟数
 * @throws 时间格式错误时抛出异常
 */
export const timeToMinutes = (timeStr: string): number => {
  if (!isValidTimeFormat(timeStr)) {
    throw new Error(`时间格式错误：${timeStr}，请使用 HH:MM 格式（如 08:30）`);
  }
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

/** HH:MM:SS 正则（可选秒） */
const TIME_WITH_SECONDS_REGEX = /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/;

/**
 * 将 HH:MM 或 HH:MM:SS 格式的时间转换为总分钟数（精确到秒，返回浮点数）
 * @param timeStr HH:MM 或 HH:MM:SS 格式时间
 * @returns 总分钟数（含小数，用于与秒级边界比较）
 * @throws 时间格式错误时抛出异常
 */
export const timeToMinutesWithSeconds = (timeStr: string): number => {
  if (!TIME_WITH_SECONDS_REGEX.test(timeStr)) {
    throw new Error(
      `时间格式错误：${timeStr}，请使用 HH:MM 或 HH:MM:SS 格式（如 08:30 或 08:30:25）`
    );
  }
  const parts = timeStr.split(':').map(Number);
  const hours = parts[0];
  const minutes = parts[1];
  const seconds = parts.length === 3 ? parts[2] : 0;
  return hours * 60 + minutes + seconds / 60;
};

/**
 * 获取当前系统时间的总分钟数（自动格式化为 HH:MM）
 * @returns 当前时间总分钟数
 */
export const getCurrentTimeInMinutes = (): number => {
  const currentTimeStr = dayjs().format('HH:mm');
  return timeToMinutes(currentTimeStr);
};

/**
 * 计算指定总时长的 1/12 分段时长（精确值，用于边界点精确到秒）
 * @param totalMinutes 总时长（分钟）
 * @returns 每段时长（分钟），精确浮点数
 */
export const calculateSegmentLength = (totalMinutes: number): number => {
  return totalMinutes / 12;
};
